import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// UI
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import { TabTypes, ContentManagementTabConfig } from "./contentManagementTypes";
import { CONTENT_MANAGEMENT_TABS } from "./contentManagementUtils/contentManagementUtils";
import "./contentManagement.scss";

const ContentManagement = () => {
  const [selectedTab, setSelectedTab] = useState<TabTypes>(
    CONTENT_MANAGEMENT_TABS[0].tabName
  );

  const navigate = useNavigate();
  const location = useLocation();

  const handleTabChange = (tabName: TabTypes) => {
    setSelectedTab(tabName);
    // change the url param as well
    navigate(`/control-center/manage-content/${tabName}`);
  };

  useEffect(() => {
    // get the tab name from the url param
    const tabName = location.pathname.split("/").pop();
    if (tabName) {
      setSelectedTab(tabName as TabTypes);
    }
  }, [location.pathname]);

  return (
    <div className="content-management-page">
      <Tabs
        id="controlled-tab-example"
        activeKey={selectedTab}
        onSelect={handleTabChange}
        className="mb-3 tabs-container"
      >
        {CONTENT_MANAGEMENT_TABS.map(
          (tabObject: ContentManagementTabConfig) => {
            const SelectedTab = tabObject.tabComponent;
            return (
              <Tab
                eventKey={tabObject.tabName}
                title={tabObject.tabTitle}
                key={tabObject.tabName}
              >
                <SelectedTab />
              </Tab>
            );
          }
        )}
      </Tabs>
    </div>
  );
};

export default ContentManagement;
